import * as PIXI from "pixi.js";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import LocalizedPIXIText from "@localisation/LocalizedPIXIText";
import Facade from "@/Facade";
import UIConfig from "@baseUI/config/UIConfig";
import SimpleTextComponent from "@baseUI/component/text/SimpleTextComponent";
import ButtonComponent from "@baseUI/component/button/ButtonComponent";

export default new class AddComponent {
    constructor () {}

    addSpineAnimation = (name, frame, container, position, scale = 1) => {
        let sa = new SpineAnimation(name)
        sa.stop()
        container.addChild(sa)
        if ( scale !== 1){
            sa.scale.set(scale)
        }
        if (position) {
            sa.position.set(...position)
        }
        return sa
    }

    addSpineAnimationPlay = (name, frame, container, position) => {
        let sa = new SpineAnimation(name)
        sa.start([frame], [true])
        container.addChild(sa)
        if (position) {
            sa.position.set(...position)
        }
        return sa
    }

    addSpineAnimationLoops = (name, frames, loops, container, position) => {
        let sa = new SpineAnimation(name)
        sa.start(frames, loops)
        container.addChild(sa)
        if (position) {
            sa.position.set(...position)
        }
        return sa
    }

    addElementSettings = (path, container, settings ) => {
        let mc = new PIXI.Sprite(PIXI.Texture.from(path))
        container.addChild(mc)
        Object.assign(mc,settings)
        return mc
    }

     addElement = (name, container, position, pref, scale = 1, anchor = 0 ) => {
        const path = pref ? pref + '/' + name : name
        let mc = new PIXI.Sprite(PIXI.Texture.from(path))
        if ( scale !== 1){
            mc.scale.set(scale)
        }
        mc.anchor.set(anchor)
        container.addChild(mc)
        if (position) {
            mc.position.set(...position)
        }
        return mc
    }

    addElementTextStyle = (name, container, position) =>{
        const mc = new Facade.textFactory.getTextWithStyle(name)
        mc.anchor.set(0.5)
        container.addChild(mc)
        if (position) {
            mc.position.set(...position)
        }
        return mc
    }

     addElementText = (name, style, container, position) => {
        const text = Facade.textFactory.getLocalizedText(name)
        let mc = new LocalizedPIXIText(text, Facade.textFactory.getStyle(style))
        mc.anchor.set(0.5)
        container.addChild(mc)
        if (position) {
            mc.position.set(...position)
        }
        return mc
    }

     addElementTextName = (name, container, position) => {
         const mc = new Facade.textFactory.getTextWithStyle(name)
         mc.anchor.set(0.5)
         container.addChild(mc)
         if (position) {
             mc.position.set(...position)
         }
         return mc
         // const text = Facade.textFactory.getLocalizedText(name)
         // return this.addElementText(text, style, container, position)
     }

    addElementBitmapText = (text, style, container, position, filters) => {
        let mc = new PIXI.BitmapText(text, style)
        mc.anchor.set(0.5)
        container.addChild(mc)
        if (filters){
            mc.filters = filters
        }
        if (position) {
            mc.position.set(...position)
        }
        return mc
    }

    addContainer = (parent, settings = {} ) => {
        let mc = new PIXI.Container()
        mc.interactive = false
        parent.addChild(mc)
        Object.assign(mc,settings)
        return mc
    }

    addShadow = (parent, rect, color = 0x000000, alpha = 0.7 ) => {
        const shadow = new PIXI.Graphics()
        if (!rect){
            rect  = { x: -UIConfig.totalWidth / 2, y: -UIConfig.totalHeight / 2, width : UIConfig.totalWidth, height: UIConfig.totalHeight}
        }
        shadow.interactive = true
        shadow.beginFill(color, alpha)
        shadow.drawRect(rect.x, rect.y, rect.width, rect.height)
        parent.addChild(shadow)
        return shadow
    }

    addElementDynamicStyleText = (style, container, position) => {
        const mc = new SimpleTextComponent(style)
        container.addChild(mc)
        if (position) {
            mc.position.set(...position)
        }
        return mc
    }

    addButton = ( textures, container, position) => {
        //const path = pref ? pref + '/' : ''
        // let btn = new PIXI.AnimatedSprite([
        //     PIXI.Texture.from(path + textures.normal),
        //     PIXI.Texture.from(path + textures.over),
        //     PIXI.Texture.from(path + textures.down),
        //     PIXI.Texture.from(path + textures.disable)
        // ])
        const btn = new ButtonComponent(textures)
        container.addChild(btn)
        if (position) {
            btn.position.set(...position)
        }
        return btn
    }

    addElementDynamicText = (style, container, position) => {
        const mc = new SimpleTextComponent(Facade.textFactory.getStyle(style))
        container.addChild(mc)
        if (position) {
            mc.position.set(...position)
        }
        return mc
    }
}()
